import { useHttp } from "../../../hooks/useHttp";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

export const useTodos = () => {
  const request = useHttp();
  const { data, isLoading } = useQuery({ queryKey: ["todos"], queryFn: () => request({ url: "/admins/to-dos", method: "GET" }) });

  return { data, isLoading };
}

export const useAddNewTodo = () => {
  const request = useHttp();
  const queryClient = new useQueryClient();

  const mutation = useMutation({
    mutationFn: todo => request({ url: `/admins/to-dos/0?method=insert`, method: "post", data: todo }),
    onSuccess: response => queryClient.setQueryData(["todos"], { data: response.data })
  });

  return mutation;
}

export const useChangeToDone = (todo) => {
  const request = useHttp();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: newTodo => request({ url: `/admins/to-dos/${todo.id}?method=put`, method: "post", data: newTodo }),
    onSuccess: res => {
      const responseTodos = res?.data;
      queryClient.setQueryData(["todos"], { data: responseTodos });
    }
  });

  return mutation;
}

export const useDeleteTodo = (todo) => {
  const request = useHttp();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: newTodo => request({ url: `/admins/to-dos/${todo.id}?method=delete`, method: "post", data: newTodo }),
    onSuccess: res => {
      const responseTodos = res?.data;
      queryClient.setQueryData(["todos"], { data: responseTodos });
    }
  });

  return mutation;
}

export const useOrderingTodos = () => {
  const request = useHttp();

  const mutation = useMutation({
    mutationFn: todos => request({ url: `/admins/to-dos/0?method=position`, method: "post", data: todos }),
    onSuccess: res => {
      console.log(res.data);
    }
  });

  return mutation;
}